module.exports = {
        srcSet: __webpack_public_path__ + "822f343fd2829d79-350.png"+" 350w",
        images: [{path: __webpack_public_path__ + "822f343fd2829d79-350.png",width: 350,height: 250}],
        src: __webpack_public_path__ + "822f343fd2829d79-350.png",
        toString: function(){return __webpack_public_path__ + "822f343fd2829d79-350.png"},
        
        width: 350,
        height: 250
      }